export default {
  computed: {
    screenSmallLength() {
      const h = window.innerHeight
      const w = window.innerWidth
      return h < w ? h : w
    },
    screenLargeLength() {
      const h = window.innerHeight
      const w = window.innerWidth
      return h > w ? h : w
    },
    ratio () {
      return this.screenSmallLength / 1080.0
    }
  },
  methods: {
    lengthAtDevice (lengthAt1080) {
      return lengthAt1080 * this.ratio
    }
  }
}
